import { Injectable } from '@angular/core';
import { SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UrlQueryStringService {
  constructor(
    private _sessionStorageService: SessionStorageService,
    private activatedRoute: ActivatedRoute
  ) {}

  checkURLQueryString() {
    const url = this.activatedRoute.snapshot.queryParams;
    if (url.hasOwnProperty('EAC') && url.EAC === '1') {
      this.setEAC(1);
    }
    if (url.hasOwnProperty('PC')) {
      this.setPromoDiscount(url.PC);
    }
  }

  setEAC(isEAC) {
    this._sessionStorageService.setSession('EAC', isEAC);
  }

  getEAC() {
    return this._sessionStorageService.getSession('EAC');
  }

  removeEAC() {
    this._sessionStorageService.removeSession('EAC');
  }

  setPromoDiscount(promoCode) {
    this._sessionStorageService.setSession('PC', promoCode);
  }

  getPromoDiscount() {
    return this._sessionStorageService.getSession('PC');
  }

  removePromoDiscount() {
    this._sessionStorageService.removeSession('PC');
  }
}
